import React from 'react'
import { Reports } from '../../../api/services/next'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { DatePicker } from '../../shared/DatePicker'
import moment from 'moment'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { Form } from 'semantic-ui-react'
import { useTextResources } from '../../../language'
import formatCurrency from 'format-currency'
import { currencyFormat } from '../../shared/utils'
import { IntegratedSummary } from '@devexpress/dx-react-grid'
import { useState } from 'react'

const TrialBalanceReport = ()=>{
    const text = useTextResources()
    const [hotelId, setHotelId] = useState(window.user?.CurrentHotel?.Id);
    const [balance, setBalance] = useState(0)
    const currencyFormatter = ({row, value}) => {
        return formatCurrency(value || 0, currencyFormat(row?.CurrencyId));
    }
    const onSearchComplete = async (data, spec)=>{
        const balance = await Reports.GetOpenBalance({hotelId, date: spec.FromDate})
        setBalance(balance)
        return true
    }
    const gridOptions = {
        search: {
            title: text("TrialBalanceReport"),
            fields: [
                <Form.Field label={text("Hotel")}
                    required
                    control={HotelsDropDown}
                    onChange={setHotelId}
                    key="HotelId" clearable width="3"
                    placeholder={text("SelectHotel")} />,
                <DatePicker label={text("SpecificDate")}
                    key="FromDate" width="2"
                    defaultValue={moment().toDate()} 
                />,
            ],
            validate: ({HotelId})=>HotelId,
            api: Reports.TrialBalanceReport,
            initial: {
                HotelId: window.user?.CurrentHotel?.Id,
                FromDate: moment().startOf('day').toDate()
            }
        },
        grid: {
            columns: [
                { name: 'Group', title: text("Group") },
                { name: 'TransactionCodeId', title: text("Code") },
                { name: 'Description', title: text("Description") },
                { name: 'Amount', title: text('Amount'), formatter: currencyFormatter },
            ],
            summary: true,
            totalSummaryItems: [
                { columnName: 'Amount', type: 'debit', formatter: currencyFormatter },
                { columnName: 'Amount', type: 'credit', formatter: currencyFormatter },
                { columnName: 'Amount', type: 'sum', formatter: currencyFormatter },
                { columnName: 'Amount', type: 'balance', formatter: currencyFormatter }
            ],
            groupSummaryItems: [
                { columnName: 'Amount', type: 'sum', showInGroupFooter: false, alignByColumn: true, formatter: currencyFormatter }
            ],
            summaryMessages: {
                debit: text("TotalDebit"),
                credit: text("TotalCredit"),
                balance: text("PreviousBalance"),
                sum: text("TotalForToday")
            },
            summaryCalculator: (type, rows, getValue) =>{
                if (type == 'debit') {
                    return IntegratedSummary.defaultCalculator('sum', rows.filter(x=>x.IsDebit), getValue);
                } else if (type == 'credit') {
                    return IntegratedSummary.defaultCalculator('sum', rows.filter(x=>!x.IsDebit), getValue);
                }  else if (type == 'balance') {
                    return balance;
                } else 
                    return IntegratedSummary.defaultCalculator(type, rows, getValue);
            },
            customOptions: {
                group: {
                    grouping: [
                        { columnName: 'Group' }
                    ]
                },
                sort: {
                    sorting: [
                        { columnName: 'TransactionCodeId', direction: 'asc' }
                    ]
                },
            },
            export: true,
            cacheId:'TrialBalanceReport',
            paging: true,
            pdf: true
        }
    }
    return (<GridSearchTemplate options={gridOptions} onSearchComplete={onSearchComplete} />)
}

export default TrialBalanceReport